module.exports = __webpack_public_path__ + "img/logogunsalong.a3ce08e5.png";